<template>
  <div
    :style="{
      textAlign: textAlign,
      width: width + '%',
      margin
    }"
  >
    <label :style="[labelStyles]">{{ labelTitle }}</label>
    <span v-if="required" class="pink--text">*</span>
    <textarea
      v-on:input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
      :required="required"
      :type="type"
      :value="value"
      :rows="rows"
      :style="[inputStyles]"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "TextAreaField",
  props: {
    value: { default: "" },
    labelTitle: { default: "label" },
    required: Boolean,
    placeholder: { default: "" },
    type: { default: "text" },
    textAlign: { default: "left" },
    width: { default: 90 },
    rows: { default: 10 },
    margin: { default: "0px auto" },
    inputStyles: {},
    labelStyles: {}
  },
  data: function() {
    return {};
  }
};
</script>

<style scoped>
textarea {
  resize: vertical;
  display: block;
  background: #ffffff;
  width: 100%;

  resize: none;

  padding: 1rem 1rem;
  margin-top: 0.7rem;

  font-size: 14px;
  font-family: "OpenSans";

  border: 1px solid #e05484;
  box-sizing: border-box;
  border-radius: 25.5px;
}

textarea::placeholder {
  color: #8a8a8a;
  font-family: "OpenSans";
  font-size: 14px;
}
</style>
